import { createStore } from 'vuex'
import { getToken } from '@/utils/auth'
import {defineComponent, getCurrentInstance} from 'vue'
export default createStore({
  state: {
    token:getToken()
  },
  getters: {
  },
  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
  },
  actions: {
    async login({ commit }){
      let params = {
        username: "18642010001",
        password: "123456",
      };
      let {ctx,appContext} = getCurrentInstance()
      const _this = ctx
      let {code,token} = await appContext.config.globalProperties.$api.login(params);
      if(code == '200'){
        console.log('登录中存起来token');
        window.localStorage.setItem("token", token);
        commit('SET_TOKEN', token)
      }
      return token
    }
  },
  modules: {
  }
})
